import { get, postQuiet, putQuiet } from 'api/apiRequest';
import { CommonErrorBody } from './types';

export type ServerActionName = {
  id: number;
  resolutionTypeId: number;
  resolutionTypeName: string;
  actionName: string;
  actionSubStatusId: number;
  actionSubStatusName: string;
  hearingDate?: string;
};

export type ActionName = {
  id: number;
  name: string;
  typeId: number;
  substatusId: number;
  hearingDate?: string;
};

export type PostParams = {
  actionName: string;
  actionSubStatusId: number;
  hearingDate?: string;
};

export type PutParams = PostParams & { id: number };

export type BadRequestError = {
  status: 400;
  error: CommonErrorBody[];
};

export const actionNames = {
  getNames: () => get<ServerActionName[]>('v1/ActionNames'),

  postNames: (params: PostParams) =>
    postQuiet<ServerActionName>('v1/ActionNames', params),

  putNames: (params: PutParams) =>
    putQuiet<ServerActionName>('v1/ActionNames', params),
};
